import FlowioPasswordInput from "./FlowioPasswordInput";

export default FlowioPasswordInput;
export type { FlowioPasswordInputProps } from "./FlowioPasswordInput";
